
import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import StatusMarkMixin from '@/features/common/mixins/statusMarkMixin';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component
export default class LastScanItem extends Mixins(StatusMarkMixin, ResponsivenessMixin) {
  @Prop({ required: true }) scan!: string;

  @Prop({ default: '' }) status!: string;
}
